import React, { createContext } from 'react'
import { AppConfig } from '../config/app-config'

export const AppConfigContext = createContext<AppConfig | undefined>(undefined)

interface AppConfigProviderProps {
  config?: AppConfig
  children: React.ReactNode
}

export const AppConfigProvider = ({ config, children }: AppConfigProviderProps) => (
  <AppConfigContext.Provider value={config}>{children}</AppConfigContext.Provider>
)
